import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { IntegrationsRoutes } from './pages/integrations';
import { SitesRoutes } from './pages/sites';

const FederatedAuthenticationPage = lazy(
  () =>
    import('./pages/federated-authentication/federated-authentication.page'),
);

export const AccountRoutes = () => {
  return (
    <Routes>
      <Route
        path="federated-authentication"
        element={<FederatedAuthenticationPage />}
      />
      <Route path="sites/*" element={<SitesRoutes />} />
      <Route path="integrations/*" element={<IntegrationsRoutes />} />
    </Routes>
  );
};
